export default __webpack_public_path__ + "media/color/xvg-edc41f36.svg";